import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { Component } from "../types/component";

export const getComponent: (config: {
  "app-id": string;
  "component-id": string;
}) => Promise<Component> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Comp "omega/query-omega/public/api/component")
        (Qo.Public.Api.Comp/get-component ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getAllComponents: (config: {
  "app-id": string;
}) => Promise<Component[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Comp "omega/query-omega/public/api/component")
        (Qo.Public.Api.Comp/get-all-available-components ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const searchComponents: (config: {
  "app-id": string;
  search: string;
}) => Promise<Component[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Comp "omega/query-omega/public/api/component")
        (= Input ${ednString})
        (Qo.Public.Api.Comp/component-search Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const setDatabasePagesToComponent: (config: {
  "component-id": string;
  "folder-id": string;
}) => Promise<Component[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Comp "omega/query-omega/public/api/component")
        (= Input ${ednString})
        (Qo.Public.Api.Comp/set-database-pages-to-component Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
